<template>
  <v-card>
    <v-card-title class="headline font-weight-thin">Delete Confirmation</v-card-title>
    <v-card-text>
      Are you sure you want to delete dropdown value
      <span class="font-weight-bold">{{ dropdownValue.label }}</span
      >?
    </v-card-text>
    <v-card-actions class="pa-4">
      <v-spacer></v-spacer>
      <v-btn @click="cancel" class="mr-2" outlined>Cancel</v-btn>
      <v-btn class="elevation-0 font-weight-bold" color="red" data-cy="confirmDelete" @click="submit" outlined
        >Delete</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  methods: {
    cancel() {
      this.$emit("setDialog", false);
    },
    async submit() {
      const { dropdownId, id, label } = this.dropdownValue;

      try {
        await this.delete({ dropdownId, id });
        this.$emit("setDialog", false);
        this.$notifySuccess({ message: `Successfully deleted ${label}` });
      } catch (e) {
        this.$notifyError({
          message: `Could not delete dropdown value.`,
        });
      }
    },
    ...mapActions({
      delete: "admin/dropdownValue/remove",
    }),
  },
  props: { dropdownValue: { required: true, type: Object } },
};
</script>
